import { MouseEvent, useEffect, useState } from 'react';
import { Steps, Step } from '@gaiads/telia-react-component-library';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ORDER_FLOW_CONSTANTS } from '../../../utils';
import { resetLocationReference } from '../../../store/order';
import { AppDispatch } from '../../../store';
import { useDispatch } from 'react-redux';

export const orderBaseUrl = '/order';

export default function OrderStepper() {
  const [stepIndex, setStepIndex] = useState(0);
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation('orderFlow');

  const activateRightStep = (path: string) => {
    if (path.includes(ORDER_FLOW_CONSTANTS.selectProduct)) {
      setStepIndex(0);
    } else if (path.includes(ORDER_FLOW_CONSTANTS.bundle)) {
      setStepIndex(0);
    } else if (path.includes(ORDER_FLOW_CONSTANTS.checkoutDetails)) {
      setStepIndex(1);
    } else if (path.includes(ORDER_FLOW_CONSTANTS.deliveryOptions)) {
      setStepIndex(2);
    } else if (path.includes(ORDER_FLOW_CONSTANTS.orderCompleted)) {
      setStepIndex(3);
    } else {
      setStepIndex(0);
    }
  };

  useEffect(() => {
    activateRightStep(location.pathname);
  }, [location.pathname]);

  const handleSelect = (_e: MouseEvent, index: number) => {
    switch (index) {
      case 0:
        dispatch(resetLocationReference());
        history.push(`${orderBaseUrl}/${ORDER_FLOW_CONSTANTS.selectProduct}`);
        break;
      case 1:
        history.push(`${orderBaseUrl}/${ORDER_FLOW_CONSTANTS.checkoutDetails}`);
        break;
      case 2:
        history.push(`${orderBaseUrl}/${ORDER_FLOW_CONSTANTS.deliveryOptions}`);
        break;
      case 3:
        history.push(`${orderBaseUrl}/${ORDER_FLOW_CONSTANTS.orderCompleted}`);
        break;
    }
  };

  const handleSelectable = (index: number, selectedStepIndex: number): boolean =>
    !(
      (selectedStepIndex === 0 && index > 0) ||
      (selectedStepIndex === 1 && index > 1) ||
      (selectedStepIndex === 2 && index > 2) ||
      (selectedStepIndex === 3 && index < 3)
    );

  return (
    <Steps selectedStepIndex={stepIndex} onSelect={handleSelect} isStepSelectable={handleSelectable}>
      <Step label="1" description={t('orderStepper.selectProduct')} />
      <Step label="2" description={t('orderStepper.checkoutDetails')} />
      <Step label="3" description={t('orderStepper.deliveryOptions')} />
      <Step label="4" description={t('orderStepper.orderCompleted')} />
    </Steps>
  );
}
